(() => {
 'use strict';
 if (window.dcSingleBakery) return;
 const root = window.Shopify?.routes?.root || '/';
 let queue = Promise.resolve();
 let dialog;
 function notice(message) {
  if (!dialog) {
   dialog = document.createElement('dialog');
   dialog.className = 'dc-single-bakery-dialog';
   dialog.setAttribute('aria-label', 'Productos de una sola pastelería');
   const text = document.createElement('p');
   const button = document.createElement('button');
   button.type = 'button'; button.textContent = 'Entendido';
   button.addEventListener('click', () => dialog.close());
   dialog.append(text, button); document.body.append(dialog);
  }
  dialog.querySelector('p').textContent = message;
  if (!dialog.open) dialog.showModal();
 }
 async function read(path, accept = 'application/json') {
  // Liquid alternate views require HTML negotiation, even when their body is JSON.
  // Retry only reads: a POST must never be repeated after an uncertain outcome.
  for (let attempt = 0; attempt < 2; attempt++) {
   const controller = new AbortController();
   const timer = setTimeout(() => controller.abort(), 12000);
   try {
    const response = await fetch(path, {credentials:'same-origin',cache:'no-store',headers:{Accept:accept},signal:controller.signal});
    if (!response.ok) throw Error('unavailable');
    return await response.json();
   } catch (error) {
    if (attempt === 1) throw error;
   } finally { clearTimeout(timer); }
  }
 }
 async function owner(handle) {
  if (typeof handle !== 'string' || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) throw Error('missing product');
  const data = await read(root+'products/'+encodeURIComponent(handle)+'?view=dulchefs-owner', 'text/html');
  if (!data || typeof data.owner !== 'string' || !data.owner.trim()) throw Error('missing owner');
  return data;
 }
 function blocked(message) {
  notice(message);
  return new Response(JSON.stringify({status:422,dcSingleBakeryBlocked:true,message,description:message}),{status:422,headers:{'Content-Type':'application/json'}});
 }
 async function guarded(handle, url, config) {
  try {
   const cart = await read(root+'cart.js');
   if (!Array.isArray(cart.items)) throw Error('invalid cart');
   const incoming = await owner(handle);
   if(window.dcExclusiveStoreId && incoming.owner!==window.dcExclusiveStoreId)return blocked('Esta elaboración pertenece a otro establecimiento.');
   const handles = [...new Set(cart.items.map(item => item.handle))];
   const existing = await Promise.all(handles.map(existingHandle => existingHandle === handle ? incoming : owner(existingHandle)));
   if (existing.some(product => product.owner !== incoming.owner)) {
    return blocked('Solo puedes incluir productos de una misma pastelería en cada compra. Para añadir productos de otra pastelería, finaliza tu compra actual o vacía el carrito y comienza una nueva.');
   }
  } catch (_) {
   return blocked('No hemos podido comprobar la pastelería de los productos. No se ha añadido el producto. Vuelve a intentarlo en unos instantes.');
  }
  return fetch(url,config);
 }
 window.dcSingleBakery = {
  add(handle,url,config) {
   const run = () => guarded(handle,url,config);
   if (navigator.locks?.request) return navigator.locks.request('dulchefs-cart-add',run);
   const result = queue.then(run,run); queue = result.catch(() => {}); return result;
  }
 };
})();
